import { render, staticRenderFns } from "./RedemptionRecordPopup.vue?vue&type=template&id=6c8ac9c5&scoped=true"
import script from "./RedemptionRecordPopup.vue?vue&type=script&lang=js"
export * from "./RedemptionRecordPopup.vue?vue&type=script&lang=js"
import style0 from "./RedemptionRecordPopup.vue?vue&type=style&index=0&id=6c8ac9c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8ac9c5",
  null
  
)

export default component.exports